type ErrorLike = {
  message: string
}

type TrackingOptions = { meta: Record<string, any> }

export const trackError = (error: Error | ErrorLike, options?: TrackingOptions) => {
  const { meta } = options || { meta: {} }

  console.error(error, {
    extra: meta,
    level: 'error',
  })
}

export const trackWarning = (message: string, options?: TrackingOptions) => {
  const { meta } = options || { meta: {} }

  console.warn(message, {
    extra: meta,
    level: 'warning',
  })
}

export const trackInfo = (message: string, options?: TrackingOptions) => {
  const { meta } = options || { meta: {} }
  console.info(message, {
    extra: meta,
    level: 'info',
  })
}
